module.exports = __webpack_public_path__ + "assets/img/5.af619333.png";